import { render, staticRenderFns } from "./Methodology.vue?vue&type=template&id=e7d51252&scoped=true&"
import script from "./Methodology.vue?vue&type=script&lang=js&"
export * from "./Methodology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d51252",
  null
  
)

export default component.exports